import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import TwoVisualsLayout from "../../layouts/two-visuals";
import { getRequest } from '../../../../api/ApiService';
import Teams from '../../../../api/Teams';
import Auth from '../../../../routes/Auth';
import styled from 'styled-components';
import { Loader } from 'react-loaders';

import DashboardBarChart from "../../../dashboard/DashboardBarChart";
import DashboardLineChart from "../../../dashboard/DashboardLineChart";

import IconTableHelp from "../../../../containers/assets/icon-table-help.svg";

const ChartWrapper = styled.div`
  padding: 20px;
`;

const ChartTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.94);
  margin-bottom: 20px;

  ${p => p.isFlex && `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `}

  img {
    display: inline-block;
    width: 14px;
    height: 14px;
    position: relative;
    top: -1px;
    margin-left: 5px;
  }
`;

const GreyText = styled.div`
  display: inline-block;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 1px;
  color: rgba(0, 27, 59, 0.6);
  margin-left: 10px;
`;

const ColorLine = styled.div`
  width: 12px;
  height: 2px;
  display: inline-block;
  position: relative;
  top: -2px;

  ${p => p.color && `
    background: ${p.color};
  `}
`;

class ResultsAreInStep5 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      teamScore: 0,
      teamGradings: null,
      loaded: false,
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;

    const gameId = Number(Auth.getGameId());
    const team = Teams.currentTeam();
    const teamId = Number(team.id);
    const roundNumber = Number(activeRound);
    const round = rounds.find(i => Number(i.number) === roundNumber);
    const roundId = round ? Number(round.id) : 0;

    getRequest(`${process.env.REACT_APP_API_URL}v2/games/teamgradings/?round=${roundId}&game=${gameId}&team=${teamId}`)
      .then(res => {
        let teamScore = 0;
        let teamGradings = null;
        if (res.body && res.body.results) {
          teamGradings = res.body;
          const data = res.body.results.find(i => (
            Number(i.game) === gameId
            && Number(i.round_number) === roundNumber
            && Number(i.team) === teamId
          ));

          if (data && data.current_weighted_value) {
            teamScore = Number(data.current_weighted_value);
          }
        }

        this.setState({
          teamScore,
          teamGradings,
          loaded: true,
        });
      })
      .catch(err => { });
  }

  render() {
    const { activeRound } = this.props;
    const { teamScore, teamGradings, loaded } = this.state;

    return loaded ? (
      <TwoVisualsLayout
        section="RESULTS ARE IN!"
        title={`Round ${activeRound} Score`}
        paragraph1={(
          <Fragment>
            Your team scored <b>{Number((teamScore * 100).toFixed(2))}%</b> for <b>Round {activeRound}</b>. Here's how your team
            performed in relation to your competitors.
          </Fragment>
        )}
        visual1={(
          <ChartWrapper>
            <ChartTitle>
              Overall Score
              <img alt="Overall Score icon help" src={IconTableHelp} />
            </ChartTitle>
            {teamGradings && (
              <DashboardBarChart
                teamGradings={teamGradings}
                round_number={activeRound}
              />
            )}
          </ChartWrapper>
        )}
        visual1Props={{
          height: '100%',
        }}
        visual2={(
          <ChartWrapper>
            <ChartTitle isFlex={true}>
              <div>
                Score Trend
                <img alt="Score Trend icon help" src={IconTableHelp} />
              </div>
              <div>
                <ColorLine color={Teams.currentTeamColorLevel3()} />
                <GreyText>Your team</GreyText>
              </div>
            </ChartTitle>
            {teamGradings && (
              <DashboardLineChart
                teamGradings={teamGradings}
                round_number={activeRound}
              />
            )}
          </ChartWrapper>
        )}
        visual2Props={{
          height: '100%',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default ResultsAreInStep5;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/results-are-in/step5.js